import React from 'react';
import { Button } from 'carbon-components-react';

export default Button;
